/**
 * init dotenv
 *
 * .env: Default.
 * .env.local: Local overrides. This file is loaded for all environments except test.
 * .env.development, .env.test, .env.production: Environment-specific settings.
 * .env.development.local, .env.test.local, .env.production.local: Local overrides of environment-specific settings.
 *
 * Available settings from baseimage
 *
 * REACT_APP_TITLE='React App'
 */

/**
 *
 * @param {string} name envrionment name
 * @param {string} init default value
 * @returns {string} value
 */
function env(name: string, init: string): string {
  const key = `REACT_APP_${name.toUpperCase()}`;
  const buildtimeValue = process.env?.[key];

  //@ts-ignore
  const runtimeValue = window._runtime_?.[key];
  const value = runtimeValue || buildtimeValue || init;

  if (value === undefined) {
    throw new Error(`environment ${name} is missing`);
  }

  return value.replace('%host%', window.location.hostname);
}

/**
 * chore
 */
export const VERSION = env('VERSION', '3.0.0');
export const BUILD = env('BUILD', '20231017-000000');
export const COPYRIGHT = env('COPYRIGHT', '36node 出品');

/**
 * app
 */
export const TITLE = env('TITLE', '违法智管系统');
export const VEHICLE_ONLY = env('VEHICLE_ONLY', 'off') === 'on';

/**
 * api
 */
export const ROOT_NS = env('ROOT_NS', 'fcp_uat');
export const AUTH_ENDPOINT = env('AUTH_ENDPOINT', 'https://fcp-uat.36node.com/auth/v1');
export const FCP_ENDPOINT = env('FCP_ENDPOINT', 'https://fcp-uat.36node.com/api');
export const ILLEGAL_EXPIRED_DAYS = parseInt(env('ILLEGAL_EXPIRED_DAYS', '3'), 10); // 违法过期天数
export const DRAFT_EXPIRED_DAYS = parseInt(env('DRAFT_EXPIRED_DAYS', '2'), 10); // 违法过期天数
export const FCP_OSS_ENDPOINT = env('FCP_OSS_ENDPOINT', 'http://fcp-uat.36node.com/api');

/**
 * login
 */
// 登录失败后锁定的时间，单位为秒
export const LOGIN_FAIL_LOCK_SECONDS = parseInt(env('LOGIN_FAIL_LOCK_SECONDS', `${5 * 60}`), 10);

/**
 * mqtt
 */
export const MQTT_URL = env('MQTT_URL', 'ws://emqx.z-aliyun-stage.36node.com:8083/mqtt');
export const MQTT_TOPIC_PREFIX = env('MQTT_TOPIC_PREFIX', '');
export const MQTT_USERNAME = env('MQTT_USERNAME', 'fcp');
export const MQTT_JWT_TOKEN = env('MQTT_JWT_TOKEN', '36node');

/**
 * 地图监控
 */
export const MAP_BOUND_SOUTH_WEST = env('MAP_BOUND_SOUTH_WEST', '28.92927024,122.31013782')
  .split(',')
  .map(parseFloat) as [number, number];
export const MAP_BOUND_NORTH_EAST = env('MAP_BOUND_NORTH_EAST', '30.7184163,120.47437365')
  .split(',')
  .map(parseFloat) as [number, number];
export const MAP_CENTER = env('MAP_CENTER', '29.85645453,121.51695313').split(',').map(parseFloat) as [number, number];
export const MAP_CURRENT_ZOOM = parseInt(env('MAP_CURRENT_ZOOM', '11'), 10); // 当前缩放
export const MAP_MIN_ZOOM = parseInt(env('MAP_MIN_ZOOM', '11'), 10); // 最小缩放
export const MAP_MAX_ZOOM = parseInt(env('MAP_MAX_ZOOM', '17'), 10); // 最大缩放
export const MAP_GANTRY_MIN_ZOOM = parseInt(env('MAP_GANTRY_MIN_ZOOM', '10'), 10); // 大于等于该zoom值之后，才会显示普通卡口
export const MAP_ENDPOINT = env('MAP_ENDPOINT', 'http://fcp-uat.36node.com/map/local/tiles');

// 客户端下载地址
export const APP_DOWNLOAD_URL = env('APP_DOWNLOAD_URL', 'https://minio-api.z-ctyun-stage.36node.com/test1/xftp.rar');

// 图片压缩阈值，超过该大小需要进行压缩，单位为kb
export const IMAGE_COMPRESS_THRESHOLD_SIZE = parseInt(env('IMAGE_COMPRESS_THRESHOLD_SIZE', '500'), 10);

// 密码过期时间
export const PASSWORD_EXPIRED_ENABLE = env('PASSWORD_EXPIRED_ENABLE', 'true').toLocaleLowerCase() === 'true';
export const PASSWORD_EXPIRED_DAYS = parseInt(env('PASSWORD_EXPIRED_DAYS', '90'), 10);
export const SHOW_DATA_YEARS = parseInt(env('SHOW_DATA_YEARS', '1'), 10);

// 浏览器下载
export const MIN_BROWSER_VERSION = parseInt(env('MIN_BROWSER_VERSION', '100'), 10); // 最低浏览器版本要求
export const BROWSER_DOWNLOAD_URL = env(
  'BROWSER_DOWNLOAD_URL',
  'https://s3.z-aliyun-stage.36node.com/fcp-dev/dev/Win_x64_1009991_chrome-win.zip'
); // Chrome浏览器下载地址

// ROBOT 接口前缀
export const ROBOT_URL_PREFIX = env('ROBOT_URL_PREFIX', 'http://');

// 监控预警最多展示数据条数
export const MONITOR_WARNING_COUNT = parseInt(env('MONITOR_WARNING_COUNT', '30'), 10);
// 监控预警最多隐藏数据条数
export const MONITOR_WARNING_HIDDEN_COUNT = parseInt(env('MONITOR_WARNING_HIDDEN_COUNT', '30'), 10);
// 监控预警时，仅展示若干时间内违法产生的预警，单位为分钟
export const MONITOR_WARNING_IGNORE_MINUTES = parseInt(env('MONITOR_WARNING_IGNORE_MINUTES', '7'), 10);

/** eslint-disabled */
console.log('TITLE', TITLE);
console.log('ROOT_NS', ROOT_NS);
console.log('AUTH_ENDPOINT', AUTH_ENDPOINT);
console.log('FCP_ENDPOINT', FCP_ENDPOINT);
console.log('FCP_OSS_ENDPOINT', FCP_OSS_ENDPOINT);
/** eslint-disabled */
